import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@bowfast/ui/components/card";
import { type ChartConfig, ChartContainer, ChartTooltipContent } from "@bowfast/ui/components/chart";
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis } from "recharts";
import type { VesselDetail } from "~/pages/vessels/vessels.types";

const activityChartConfig: ChartConfig = {
  nm: { label: "Crew", color: "var(--color-abyss-500)" },
};

export function VesselActivityChart({ assignments }: Readonly<{ assignments: VesselDetail["expeditionAssignments"] }>) {
  const data = assignments.map((ea) => ({
    name: ea.expedition.name.slice(0, 12),
    nm: ea.expedition.crew.length,
  }));
  const totalCrew = assignments.reduce((s, ea) => s + ea.expedition.crew.length, 0);
  const avgCrew = assignments.length > 0 ? Math.round(totalCrew / assignments.length) : 0;
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-[0.9375rem] font-semibold">Expedition Activity</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ChartContainer config={activityChartConfig} className="aspect-auto h-32 w-full">
          <BarChart data={data} barCategoryGap="20%" margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
            <CartesianGrid vertical={false} strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tick={{ fill: "var(--color-muted-foreground)", fontSize: 11, fontWeight: 500 }}
            />
            <Tooltip content={<ChartTooltipContent />} />
            <Bar dataKey="nm" fill="var(--color-abyss-500)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="flex items-center justify-between border-t px-6 py-3">
        <span className="text-xs text-muted-foreground">Avg. crew per expedition</span>
        <span className="font-heading text-sm font-bold tabular-nums">{avgCrew}</span>
      </CardFooter>
    </Card>
  );
}
